import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { ArrowRight } from 'lucide-react';
export function Treatments() {
  const treatments = [{
    title: 'Rejuvenecimiento Facial',
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&q=80&w=800',
    description: 'Restaura la juventud y vitalidad de tu rostro con técnicas no invasivas.'
  }, {
    title: 'Medicina Estética Facial',
    image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?auto=format&fit=crop&q=80&w=800',
    description: 'Armonización facial, toxina botulínica y rellenos dérmicos de alta gama.'
  }, {
    title: 'Tratamientos Corporales',
    image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=800',
    description: 'Soluciones efectivas para celulitis, flacidez y bienestar corporal.'
  }, {
    title: 'Body Contouring',
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&q=80&w=800',
    description: 'Esculpe tu figura eliminando la grasa localizada sin cirugía.'
  }, {
    title: 'Skin Quality',
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&q=80&w=800',
    description: 'Mejora la textura, luminosidad y salud profunda de tu piel.'
  }, {
    title: 'Tecnología Láser',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&q=80&w=800',
    description: 'Plataformas lumínicas de última generación para manchas, cicatrices y depilación.'
  }];
  return <section id="tratamientos" className="py-24 md:py-32 bg-surface" data-id="element-250">
      <div className="container mx-auto px-6 md:px-12" data-id="element-251">
        <SectionHeading title="Nuestros Tratamientos" subtitle="Descubre nuestra selección de procedimientos médicos estéticos diseñados para ofrecerte resultados excepcionales y naturales." data-id="element-252" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16" data-id="element-253">
          {treatments.map((treatment, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-254">
              <div className="group cursor-pointer rounded-2xl overflow-hidden relative aspect-[4/5]" data-id="element-255">
                {/* Image Background */}
                <div className="absolute inset-0" data-id="element-256">
                  <img src={treatment.image} alt={treatment.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-257" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black-premium/80 via-black-premium/20 to-transparent" data-id="element-258" />
                </div>

                {/* Content */}
                <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-259">
                  <div className="transform transition-transform duration-500 translate-y-4 group-hover:translate-y-0" data-id="element-260">
                    <h3 className="font-serif text-2xl text-white mb-3" data-id="element-261">
                      {treatment.title}
                    </h3>
                    <p className="text-white/80 font-light text-sm mb-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-262">
                      {treatment.description}
                    </p>
                    <div className="flex items-center gap-2 text-gold text-sm font-medium uppercase tracking-widest" data-id="element-263">
                      <span data-id="element-264">Descubrir</span>
                      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-2" data-id="element-265" />
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}